
// src/pages/History/AncientHistory/HistoryPageHan.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Han_Dynasty_China.png';

export default function HistoryPageHan() {
  return (
    <TopicPage
      topicKey="Han Dynasty (China)"
      title="History: Han Dynasty"
      backgroundImage={bg}
      startRoute="/History-Han-Dynasty-Go"
      scrollLabels={[
        "Rise of the Han",
        "Economy and Technology",
        "Silk Road and Decline",
      ]}
    backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}